import React from 'react';
import { DonutChart as TremorDonutChart } from "@tremor/react";

const DonutChart = ({ 
  data, 
  category, 
  index, 
  colors, 
  valueFormatter 
}) => {
  return (
    <TremorDonutChart
      data={data}
      category={category}
      index={index}
      colors={colors}
      valueFormatter={valueFormatter}
      showAnimation={true}
      showTooltip={true}
      className="h-full"
      customTooltip={(props) => {
        const { payload, active } = props;
        if (!active || !payload) return null;
        return (
          <div className="bg-white/95 backdrop-blur-sm p-2.5 rounded-lg shadow-lg border border-gray-100 min-w-[140px]">
            <div className="flex items-center space-x-1.5 mb-1">
              <div className="w-2 h-2 rounded-full" style={{ backgroundColor: payload[0].payload.color }} />
              <p className="text-xs font-medium text-gray-800">{payload[0].name}</p>
            </div>
            <div className="pl-3.5">
              <p className="text-sm font-semibold text-gray-900">{valueFormatter(payload[0].value)}</p>
            </div>
          </div>
        );
      }}
    />
  );
};

export default DonutChart; 